import { Button } from "@mantine/core";
import { useDispatch, useSelector } from "../../../redux/hooks";
import { setNMEAModalData } from "../../../redux/slices/generatorFeaturesSlice";

const ReopenNMEAModalButton = () => {
  const dispatch = useDispatch();
  const { lbentry } = useSelector(s => s.generatorSlice);

  const handleOpen = () => {
    dispatch(setNMEAModalData({ opened: true }));
  };

  if (!lbentry.NMEA || !lbentry?.NMEAData) return null;
  return (
    <Button ml={15} onClick={handleOpen}>
      View NMEA Data
    </Button>
  );
};
export default ReopenNMEAModalButton;
